import { deleteApiCaller, getApiCaller, postFormDataApiCaller, putApiCaller, putFormDataApiCaller } from "../apiCaller";

export const getBooks = async (currentPage, itemsPerPage, search, categoryId = undefined) => {
    let url = `book/get-all?page=${currentPage}&limit=${itemsPerPage}&search=${search}&includeHidden=true`;
    if (categoryId !== undefined) {
        url += `&categoryId=${categoryId}`;
    }
    const response = await getApiCaller(url);
    return response;
}

export const addBook = async (payload) => {
    const response = await postFormDataApiCaller("book/create", payload);
    return response;
}

export const updateBook = async (id, payload) => {
    const response = await putFormDataApiCaller(`book/update/${id}`, payload);
    return response;
}

export const deleteBook = async (id) => {
    const response = await deleteApiCaller(`book/delete/${id}`);
    return response;
}

export const bookSequence = async (payload) => {
    const response = await putApiCaller("book/sequence", payload);
    return response;
}

export const swapBookWithPage = async (payload) => {
    const response = await putApiCaller("book/swap-page", payload);
    return response;
}
